import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TaskStatusService } from './task-status.service';

@Component({
    selector: 'app-on-premise-sync-progress-dialog',
    templateUrl: './on-premise-sync-progress-dialog.component.html',
    styleUrl: './on-premise-sync-progress-dialog.component.scss',
    standalone: false
})
export class OnPremiseSyncProgressDialogComponent implements OnInit, OnDestroy {
  tasks: Map<string, boolean> = new Map();
  private taskStatusSubscription: Subscription;

  constructor(private taskStatusService: TaskStatusService) { }

  ngOnInit(): void {
    this.taskStatusSubscription = this.taskStatusService.tasksStatus$.subscribe(status => {
      this.tasks = new Map(status);
    });
  }

  ngOnDestroy(): void {
    this.taskStatusSubscription.unsubscribe();
  }
}
